<template>
  <header class="app-header navbar">
    <button class="navbar-toggler mobile-sidebar-toggler d-lg-none" type="button" @click="mobileSidebarToggle">&#9776;</button>
    <b-link class="navbar-brand" to="#"></b-link>
    <button class="navbar-toggler sidebar-toggler d-md-down-none" type="button" @click="sidebarMinimize">&#9776;</button>
    <b-nav is-nav-bar class="d-md-down-none">
      <b-nav-item class="px-3" href="http://servicios.facturando.mx/" v-b-tooltip.hover title="Servicio que permite monitoriar la disponibilidad de los servidores del SAT." target="_blank">Servicios</b-nav-item>
      <b-nav-item class="px-3" href="https://www.conectorcfdi.com/" v-b-tooltip.hover title="Aplicación que permite realizar el envío de facturas de los proveedores a Soriana." target="_blank">Conector CFDI</b-nav-item>
      <b-nav-item class="px-3" href="http://validarcfdi.com/" v-b-tooltip.hover title="Aplicación que permite llevar a cabo la validación de CFDIs emitidos y/o recibidos." target="_blank">Validador CFDI</b-nav-item>
    </b-nav>
    <b-nav is-nav-bar class="ml-auto">
      <b-nav-item-dropdown right>
        <template slot="button-content">
          <!-- <img src="static/img/avatars/6.jpg" class="img-avatar" alt="admin@bootstrapmaster.com"> -->
          <span class="d-md-down-none">Administrador</span>
        </template>
        <b-dropdown-item href="#" @click="logout"><i class="fa fa-lock"></i> Salir</b-dropdown-item>
      </b-nav-item-dropdown>
    </b-nav>
    <div style="width:20px"></div>
  </header>
</template>
<script>
import store from '@/store'
export default {
  name: 'header',
  methods: {
    sidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-hidden')
    },
    sidebarMinimize (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-minimized')
    },
    mobileSidebarToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('sidebar-mobile-show')
    },
    asideToggle (e) {
      e.preventDefault()
      document.body.classList.toggle('aside-menu-hidden')
    },
    logout: function () {
      store.commit('authLogout', '')
      this.$router.push('/login')
    }
  }
}
</script>
<style>
.app-header.navbar .navbar-brand {
  background-image: url(../../static/img/logo70.png) !important;
  background-size: 30px;
}
</style>


// WEBPACK FOOTER //
// src/components/Header.vue